import "@/App.css";
import { BrowserRouter, Routes, Route, useParams } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import LandingPage from "@/pages/LandingPage";
import QuoteTunnel, { QUOTE_TYPES } from "@/pages/QuoteTunnel";
import DevisAuto from "@/pages/DevisAuto";
import DevisCompletV2 from "@/pages/DevisCompletV2";
import AssuranceTemporaire from "@/pages/AssuranceTemporaire";
import Dashboard from "@/pages/Dashboard";
import AdminDashboard from "@/pages/AdminDashboard";
import ProductPage from "@/pages/ProductPage";
import ParticuliersPage from "@/pages/ParticuliersPage";
import ProfessionnelsPage from "@/pages/ProfessionnelsPage";
import FormationCourtier from "@/pages/FormationCourtier";
import PaymentResult from "@/pages/PaymentResult";
import { AutoMotoCalc, RCDecennaleCalc, MultirisqueProCalc, HabitationCalc, CyberCalc } from "@/pages/Calculators";
import WhatsAppButton from "@/components/WhatsAppButton";
import AIChatBot from "@/components/AIChatBot";
import { useLocation } from "react-router-dom";

const FloatingWidgets = () => {
  const { pathname } = useLocation();
  if (pathname.startsWith("/admin")) return null;
  const bar = mobileBarVisible(pathname);
  return (
    <>
      <div className={bar ? "hidden md:block" : ""}><WhatsAppButton /></div>
      <AIChatBot raised={bar} />
      <MobileActionBar />
      <CookieBanner />
    </>
  );
};
import { CookieBanner } from "@/components/CookieBanner";
import { MobileActionBar, mobileBarVisible } from "@/components/MobileActionBar";
import { MentionsLegales, PolitiqueConfidentialite } from "@/pages/LegalPages";
import ConfiancePage from "@/pages/ConfiancePage";
import DepartmentPage from "@/pages/DepartmentPage";
import NotFoundPage from "@/pages/NotFoundPage";
import { DEPARTMENTS } from "@/data/departments";
import AITracker from "@/components/AITracker";
import SEOHead from "@/components/SEOHead";

const QuoteTunnelRoute = () => (QUOTE_TYPES.includes(useParams().type) ? <QuoteTunnel /> : <NotFoundPage />);

function App() {
  return (
    <div className="App min-h-screen bg-background">
      <BrowserRouter>
        {/* SEO et Schema.org */}
        <SEOHead />
        
        {/* Agent de Tracking Invisible */}
        <AITracker />
        
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/particuliers" element={<ParticuliersPage />} />
          <Route path="/professionnels" element={<ProfessionnelsPage />} />
          <Route path="/temporaire" element={<AssuranceTemporaire />} />
          <Route path="/formation-courtier" element={<FormationCourtier />} />
          <Route path="/produit/:type" element={<ProductPage />} />
          <Route path="/devis/auto" element={<AutoMotoCalc />} />
          <Route path="/devis/moto" element={<AutoMotoCalc />} />
          <Route path="/devis/rc-decennale" element={<RCDecennaleCalc />} />
          <Route path="/devis/rc_decennale" element={<RCDecennaleCalc />} />
          <Route path="/devis/multirisque-pro" element={<MultirisqueProCalc />} />
          <Route path="/devis/multirisque_pro" element={<MultirisqueProCalc />} />
          <Route path="/devis/habitation" element={<HabitationCalc />} />
          <Route path="/devis/multirisque" element={<HabitationCalc />} />
          <Route path="/devis/cybersecurite" element={<CyberCalc />} />
          <Route path="/devis/complet" element={<DevisCompletV2 />} />
          <Route path="/devis/:type" element={<QuoteTunnelRoute />} />
          <Route path="/confiance" element={<ConfiancePage />} />
          {DEPARTMENTS.map((d) => <Route key={d.slug} path={`/${d.slug}`} element={<DepartmentPage slug={d.slug} />} />)}
          <Route path="/mentions-legales" element={<MentionsLegales />} />
          <Route path="/politique-de-confidentialite" element={<PolitiqueConfidentialite />} />
          <Route path="/payment/success" element={<PaymentResult />} />
          <Route path="/payment/cancel" element={<PaymentResult />} />
          <Route path="/espace-client" element={<Dashboard />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
        
        {/* Boutons flottants */}
        <FloatingWidgets />
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
